// Breakpoints
const tabletBreakPoint = 1024;
const mobileBreakPoint = 620;

// Elements
const tabSection = document.querySelector('.pdp-tabs-v3');
const skuSpan = document.getElementById('variant-sku');
const barcodeSpan = document.getElementById('variant-barcode');
const tabsList = document.querySelectorAll('.tab-item');
const tabIcons = document.querySelectorAll('.tab-icon');
const variantImages = document.querySelectorAll('.variant-image');
const readMoreBtns = document.querySelectorAll('.read-more-btn');

const hamburgerBtn = document.querySelector('.product-v3 .hamburger-btn');
const navBuyNowBtn = document.querySelector('.pdp-breadcrumb-submenu-v3 .buy-now-btn');
const navAddToCartContainer = document.querySelector('.pdp-breadcrumb-submenu-v3 .nav-add-to-cart');
const navLinksWrapper = document.querySelector('.pdp-breadcrumb-submenu-v3 .nav-links-wrapper');
const navCloseIcon = document.querySelector('.pdp-breadcrumb-submenu-v3 .xmark-solid');
const btnTextSpan = document.querySelector('.pdp-breadcrumb-submenu-v3 .buy-now-btn .btn-text-span');

////////////////////////////////////
//pdp-gallery-v3.js
////////////////////////////////////

// Vimeo Thumbnail Fetching and Modal Handling
document.querySelectorAll('.rr-video-thumbnail-container').forEach(container => {
    const vimeoUrl = container.getAttribute('data-vimeo-url');
    if (!vimeoUrl) return;

    const apiUrl = `https://vimeo.com/api/oembed.json?url=https://vimeo.com/${vimeoUrl}`;

    fetch(apiUrl)
        .then(response => response.json())
        .then(data => {
            const img = document.createElement('img');
            img.src = data.thumbnail_url;
            img.alt = data.title || 'Vimeo thumbnail';
            img.classList.add('rr-video-thumbnail');
            container.appendChild(img);
        })
        .catch(console.error);
    }
);

//Video Title Fetching
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.video-title-v3').forEach(async (el) => {
        const videoId = el.getAttribute('data-vimeo-url');
        if (!videoId) return;

        try {
        const response = await fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}`);
        const data = await response.json();

        if (data && data.title) {
            el.textContent = data.title;
        } else {
            el.textContent = 'Untitled video';
        }
        } catch (error) {
        console.error(`Error fetching Vimeo title for ${videoId}:`, error);
        el.textContent = 'Video unavailable';
        }
    });
});

document.querySelectorAll('.rr-modal-toggle').forEach(button => {
    button.addEventListener('click', function () {
        const modal = document.querySelector('.rr-video-modal');
        if (modal.style.display === 'flex') {
            const iframes = modal.querySelectorAll('iframe');
            iframes.forEach((iframe) => {
                try {
                    if (window.Vimeo && Vimeo.Player) {
                        const player = new Vimeo.Player(iframe);
                        player.unload().catch(() => {});
                    } else {
                        if (iframe.contentWindow) {
                            iframe.contentWindow.postMessage('{"method":"pause"}', '*');
                        }
                        const src = iframe.getAttribute('src');
                        iframe.setAttribute('src', '');
                        requestAnimationFrame(() => iframe.setAttribute('src', src));
                    }
                } catch (e) { /* noop */ }
            });

            modal.style.display = 'none';
            document.body.classList.remove('modal-open');
        } else {
            modal.style.display = 'flex';
            document.body.classList.add('modal-open');
        }
    });
});

const modal = document.querySelector('.popout-overlay');
const popOut = document.querySelector('.popout-container');

popOut.addEventListener('click', e => e.stopPropagation());

document.querySelectorAll('.popout-toggle').forEach(button => {
    button.addEventListener('click', function () {
        const contentContainerId = button.dataset.metafieldKey;
        const contentContainer = document.querySelector('.asset-container.' + contentContainerId);
        const popOutCloseBtn = document.querySelector('.popout-toggle.' + contentContainerId);

        if (contentContainerId) {
            contentContainer.classList.toggle('active');
            popOutCloseBtn.classList.toggle('active');
        }

        if (modal.style.display === 'flex') {
            modal.style.display = 'none';
            document.body.classList.remove('modal-open');
            popOut.classList.remove('active');
        } else {
            modal.style.display = 'flex';
            document.body.classList.add('modal-open');
             setTimeout(() => {
                popOut.classList.add('active');
            }, 300);
        }
    });
});

modal.addEventListener('click', () => {
    const activeCloseBtn = document.querySelector('.close-button.active');

    if (activeCloseBtn) {
        const key = activeCloseBtn.dataset.metafieldKey;
        const contentContainer = document.querySelector('.asset-container.' + key);
        const popOutCloseBtn = document.querySelector('.popout-toggle.' + key);

        modal.style.display = 'none';
        contentContainer.classList.remove('active');
        popOutCloseBtn.classList.remove('active');
        popOut.classList.remove('active');

        document.body.classList.remove('modal-open');
    }
})
/*
const nav = document.querySelector('.product-v3 .nav-links-wrapper');

window.addEventListener('resize', () => {
    if (window.innerWidth > 1600) {
        nav.classList.remove('active');
    }
});
*/

hamburgerBtn.addEventListener('click', () => {
    if (window.innerWidth < 1600) {
        navLinksWrapper.classList.toggle('active');
        navAddToCartContainer.classList.remove('active');
        navBuyNowBtn.classList.remove('active');
        navCloseIcon.classList.remove('active');
        btnTextSpan.classList.add('active');
    }
});

navBuyNowBtn.addEventListener('click', () => {
    navBuyNowBtn.classList.toggle('active');
    navCloseIcon.classList.toggle('active');
    btnTextSpan.classList.toggle('active');

    const wrapperIsActive = navLinksWrapper.classList.contains('active');

    if (window.innerWidth > 1600) {
        if (wrapperIsActive) {
            navLinksWrapper.classList.remove('active');
            setTimeout(() => navAddToCartContainer.classList.add('active'), 300);
        } else {
            navAddToCartContainer.classList.remove('active');
            setTimeout(() => navLinksWrapper.classList.add('active'), 300);
        }
    } else {
        navAddToCartContainer.classList.toggle('active');
        navLinksWrapper.classList.add('active');
    }
});

//ZOOM POPUP
const windowWidth = window.innerWidth;
const windowHeight = window.innerHeight;

// Only enable zoom popup on desktop / landscape
if (windowWidth > windowHeight) {
    const zoomPopup = document.querySelector(".zoom-popup");
    const images = document.querySelectorAll(".main-image li img");

    images.forEach(img => {
        img.addEventListener("mouseenter", () => {
            zoomPopup.style.display = "block";
            zoomPopup.style.backgroundImage = `url(${img.src})`;
        });

        img.addEventListener("mouseleave", () => {
            zoomPopup.style.display = "none";
        });

        img.addEventListener("mousemove", (e) => {
            const rect = img.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            const zoomFactor = 3;
            const bgWidth = img.offsetWidth * zoomFactor;
            const bgHeight = img.offsetHeight * zoomFactor;

            let bgX = x * zoomFactor - zoomPopup.offsetWidth / 3;
            let bgY = y * zoomFactor - zoomPopup.offsetHeight / 3;

            bgX = Math.max(0, Math.min(bgX, bgWidth - zoomPopup.offsetWidth));
            bgY = Math.max(0, Math.min(bgY, bgHeight - zoomPopup.offsetHeight));

            zoomPopup.style.backgroundImage = `url(${img.src})`;
            zoomPopup.style.backgroundSize = `${bgWidth}px ${bgHeight}px`;
            zoomPopup.style.backgroundPosition = `-${bgX}px -${bgY}px`;
        });
    });
}

////////////////////////////////////
//pdp-variant-selector-v3
////////////////////////////////////

//VARIANT SELECTOR ELEMENT UPDATER
const priceSpans = document.querySelectorAll('.product-price-v3');
const comparePriceSpans = document.querySelectorAll('.compare-at-price-v3');
const savedTextSpans = document.querySelectorAll('.product-save-text-v3');
const saveText = window.translations.save;
const savedAmountSpans = document.querySelectorAll('.product-saving');
const savingsContainers = document.querySelectorAll('.price-saving-container-v3');
const exVatPriceContainer = document.getElementById('ex-vat-container-v3');
const exVatPriceSpan = document.getElementById('exvat-amount-v3');
const klarnaPriceSpan = document.getElementById('product-klarna-price-v3');
const iwocaPriceSpan = document.getElementById('product-iwoca-price-v3');
const variantSelectorBtns = document.querySelectorAll('.variant-selector-btn');
const variantSelectorSelect = document.querySelectorAll('.variant-selector-select');
const formInputVariantIds = document.querySelectorAll('.product-add-to-cart-form-v3 input[name="id"]');
const variantTitles = document.querySelectorAll('.variant-title');
const evoPointsSpan = document.getElementById('total-points-span');

document.addEventListener('DOMContentLoaded', () => {
    if (!savedTextSpans.textContent) {
        savingsContainers.forEach(e => {e.classList.remove('active');});
    } else {
        savingsContainers.forEach(e => {e.classList.add('active');});
    }
});

variantSelectorBtns.forEach(button => {
    button.addEventListener('click', function() {
        const variantIdData = button.getAttribute('data-id');
        const variantTitleData = button.getAttribute('data-title');
        const priceData = button.getAttribute('data-price');
        const evoPoints = button.getAttribute('data-evo-points');
        const comparePriceData = button.getAttribute('data-compare-price'); 
        const savedAmountData = button.getAttribute('data-saved-amount');
        const exVatPriceData = button.getAttribute('data-ext-vat-price');
        const klarnaPriceData = button.getAttribute('data-klarna-price');
        const iwocaPriceData = button.getAttribute('data-iwoca-price');
        const imageUrl = button.getAttribute('data-featured-image-url');

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantIdData);
        history.replaceState(null, '', url);

        variantSelectorSelect.forEach(select => {
            const matchingOption = [...select.options].find(
                option => option.dataset.id === variantIdData
            );

            if (matchingOption) {
                matchingOption.selected = true;
                select.dispatchEvent(new Event('change'));
            }
        });

        if (priceSpans.length > 0) {
            priceSpans.forEach(span => {
                span.textContent = priceData;
            });
        }

        if (comparePriceSpans.length > 0) {
            comparePriceSpans.forEach(span => {
                span.textContent = comparePriceData;
            });
        }

        if (formInputVariantIds.length > 0) {
            formInputVariantIds.forEach(input => {
                input.value = variantIdData;
            });
        }

        if (variantTitles.length > 0) {
            variantTitles.forEach(e => {
                e.textContent = variantTitleData;
            });
        }

        if (exVatPriceSpan) { 
            exVatPriceSpan.textContent = exVatPriceData; 
        }

        if (savedAmountData.includes('-')) {
            savingsContainers.forEach(e => {e.classList.remove('active')});
        } else {
            savingsContainers.forEach(e => {e.classList.add('active')});
        }

        if (savedAmountSpans.length > 0) {
            savedTextSpans.forEach(e => {e.textContent = saveText;});
            savedAmountSpans.forEach(e => {e.textContent = savedAmountData;});
        }

        if (klarnaPriceSpan) {
            klarnaPriceSpan.textContent = klarnaPriceData;
        }

        if (iwocaPriceSpan) {
            iwocaPriceSpan.textContent = iwocaPriceData;
        }

        if (evoPointsSpan) {
            evoPointsSpan.textContent = evoPoints;
        }

        skuSpan && (skuSpan.textContent = button.dataset.sku);
        barcodeSpan && (barcodeSpan.textContent = button.dataset.barcode);
        

        if (imageUrl) {
            const targetThumb = Array.from(thumbnailImageList).find(li => li.dataset.full === imageUrl);
            if (targetThumb.length > 0) {
                thumbnails.forEach(t => t.classList.remove("active"));
                targetThumb.forEach(t => t.classList.add('active'));
            }
            updateAcvitveImage(imageUrl);
        }

        if (variantImages.length > 0) {
            variantImages.forEach(image => {
                image.src = imageUrl;
            })
        }

        variantSelectorBtns.forEach(btn => {
            const checkmarkContainer = btn.querySelector('.checkmark-container');
            btn.classList.remove('active')
            if (checkmarkContainer) checkmarkContainer.classList.remove('active-checkmark');
        });
        
        button.classList.add('active');
        const checkmarkContainer = button.querySelector('.checkmark-container');
        if (checkmarkContainer) checkmarkContainer.classList.add('active-checkmark');
    })
});

variantSelectorSelect.forEach(select => {
    select.addEventListener('change', () => {
        const selectedVariant = select.options[select.selectedIndex];
        const selectedVariantId = selectedVariant.dataset.id;
        const matchingButton = Array.from(variantSelectorBtns).find(btn => btn.dataset.id === selectedVariantId);
        matchingButton.click();
    })
});

document.addEventListener('DOMContentLoaded', () => {
  try {
    const params = new URLSearchParams(window.location.search);
    let variantIdFromUrl = params.get('variant');

    if (!variantIdFromUrl) {
      const pathMatch = window.location.pathname.match(/\/(\d+)$/);
      if (pathMatch) variantIdFromUrl = pathMatch[1];
    }

    if (!variantIdFromUrl) return;

    const targetBtn = Array.from(document.querySelectorAll('.variant-selector-btn'))
      .find(btn => btn.getAttribute('data-id') === String(variantIdFromUrl));

    if (targetBtn) {
      targetBtn.click();

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantIdFromUrl);
      history.replaceState(null, '', url);
    }
  } catch (e) {
    console.error('Variant preselect error:', e);
  }
});


//QUANTITY INPUT INCREASE?DECREASE BUTTON HANDLER
document.querySelectorAll('.quantity-selector button').forEach(function (btn) {
    btn.addEventListener('click', function () {
        const quantityWrapper = btn.closest('.quantity-selector');
        const quantityInput = quantityWrapper.querySelector('input[type="number"]');

        if (!quantityInput) return;

        let currentValue = parseInt(quantityInput.value, 10) || 1;

        if (btn.textContent.trim() === '+') {
            quantityInput.value = currentValue + 1;
        } else if (btn.textContent.trim() === '-') {
            if (currentValue > 1) {
                quantityInput.value = currentValue - 1;
            }
        }
    });
});

////////////////////////////////////
// OVERFLOW BORDER HELPER
////////////////////////////////////
function updateOverflowBorders(root = document) {
  const targets = root.querySelectorAll
    ? root.querySelectorAll('.overflow-border')
    : []; // root may be an element or document

  targets.forEach(el => {
    const isOverflowing = el.scrollWidth > el.clientWidth;
    el.classList.toggle('active', isOverflowing);
  });
}

// Optional: keep them updated if their size/content changes
function attachResizeObservers() {
  if (!('ResizeObserver' in window)) return;
  const ro = new ResizeObserver(entries => {
    for (const { target } of entries) {
      const isOverflowing = target.scrollWidth > target.clientWidth;
      target.classList.toggle('active', isOverflowing);
    }
  });
  document.querySelectorAll('.overflow-border').forEach(el => ro.observe(el));
}

////////////////////////////////////
// LAZY LOAD FOR OFF-SCREEN IMAGES
// + SECTION REVEAL ON SCROLL
////////////////////////////////////
document.addEventListener('DOMContentLoaded', () => {
  const lazyImages   = document.querySelectorAll('img[data-src]');
  const lazySections = document.querySelectorAll('.lazy-section');
  const lazyIframes  = document.querySelectorAll('iframe[data-src]');

  // Initial check (in case some are already present)
  updateOverflowBorders();
  attachResizeObservers();

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const target = entry.target;

      // Handle images
      if (target.tagName === 'IMG' && target.dataset.src) {
        target.src = target.dataset.src;
        target.removeAttribute('data-src');
        target.onload = () => {
          target.classList.add('loaded');
          // After the image paints, re-check any overflow containers in the same section / DOM
          requestAnimationFrame(() => updateOverflowBorders(document));
        };
      }

      // Handle iframes (YouTube/Vimeo/etc)
      if (target.tagName === 'IFRAME' && target.dataset.src) {
        target.src = target.dataset.src;
        target.removeAttribute('data-src');
        target.addEventListener('load', () => {
          target.classList.add('loaded');
          requestAnimationFrame(() => updateOverflowBorders(document));
        });
      }

      // Handle sections
      if (target.classList.contains('lazy-section')) {
        target.classList.add('section-visible');
        // Wait a frame so layout settles, then check overflow inside this section only
        requestAnimationFrame(() => updateOverflowBorders(target));
      }

      obs.unobserve(target);
    });
  }, {
    root: null,
    rootMargin: '100px',
    threshold: 0.1
  });

  [...lazyImages, ...lazySections, ...lazyIframes].forEach(el => observer.observe(el));

  // Re-check on resize (throttled to rAF)
  let resizeScheduled = false;
  window.addEventListener('resize', () => {
    if (resizeScheduled) return;
    resizeScheduled = true;
    requestAnimationFrame(() => {
      resizeScheduled = false;
      updateOverflowBorders();
    });
  });

  // Also re-check once all blocking resources are done
  window.addEventListener('load', () => updateOverflowBorders());
});

// Tabs: scope per wrapper (desktop + mobile act independently)
(function initTabs() {
  document.querySelectorAll('.tabs-wrapper').forEach(wrapper => {
    const tabsList     = wrapper.querySelectorAll('.tab-item');
    const tabsInfoContents = wrapper.querySelectorAll('.info-content');
    const tabIcons     = wrapper.querySelectorAll('.tab-icon');

    function activate(tab) {
      const tabName = tab.getAttribute('data-tab');
      const matchingContent = wrapper.querySelector(`.info-content[data-tab="${tabName}"]`);
      const tabIcon = tab.querySelector('.tab-icon');

      tabsList.forEach(item => item.classList.remove('active'));
      tabIcons.forEach(icon => (icon.textContent = '+'));
      tabsInfoContents.forEach(content => content.classList.remove('active'));

      tab.classList.add('active');
      if (matchingContent) matchingContent.classList.add('active');
      if (tabIcon) tabIcon.textContent = '-';
    }

    tabsList.forEach(tab => tab.addEventListener('click', () => activate(tab)));

    // Ensure each wrapper has a default active tab/content
    const defaultActive = wrapper.querySelector('.tab-item.active') || tabsList[0];
    if (defaultActive) activate(defaultActive);
  });
})();

const mobileTabs = document.querySelectorAll('.tabs-wrapper.mobile .tab-item');

mobileTabs.forEach(tab => {
    tab.addEventListener('click', () => {
        tab.scrollIntoView({
            behavior: 'smooth'
        });
    })
});

const mobileShowMoreTabButtons = document.querySelectorAll('.show-more-btn');

mobileShowMoreTabButtons.forEach(button => {
    button.addEventListener('click', () => {
        if (button.textContent.trim() === window.translations.showMore) {
            button.textContent = window.translations.showLess;
        } else {
            button.textContent = window.translations.showMore;
        }
        const tabContent = document.querySelector(`.tabs-wrapper.mobile .tab-content-wrap[data-tab="${button.dataset.tab}"]`);
        tabContent.classList.toggle('full-height');
    })
});

const payLaterTabs = document.querySelectorAll('.pay-later-tab');
const payLaterContents = document.querySelectorAll('.pay-later-tab-content');

payLaterTabs.forEach(payLaterTab => {
    payLaterTab.addEventListener('click', () => {
        payLaterTabs.forEach(t => t.classList.remove('pay-later-active'));
        payLaterContents.forEach(c => c.classList.remove('pay-later-active'));
        const target = document.querySelectorAll(`[data-rr-pay-later-tab="${payLaterTab.dataset.rrPayLaterTab}"]`);
        target.forEach(t => { t.classList.add('pay-later-active')});
    });
});

document.querySelectorAll('.nav-link-a').forEach(link => {
    link.addEventListener('click', () => {

        if (!link.dataset.tab) {
        } else {
            tabSection.scrollIntoView({ behavior: 'smooth' });

            const tabData = link.dataset.tab;
            const targetElement = document.querySelectorAll('.pdp-tabs-v3 .' + tabData);
            const infoContents = document.querySelectorAll('.pdp-tabs-v3 .info-content');

            if (targetElement) {
                tabsList.forEach(item => item.classList.remove('active'));
                tabIcons.forEach(icon => (icon.textContent = '+'));
                tabsList.forEach(item => {
                    if(item.dataset.tab === tabData) {
                        item.classList.add('active');
                    }
                });
                tabIcons.forEach(icon => {
                    if(icon.parentElement.dataset.tab === tabData) {    
                        icon.textContent = '-';
                    }
                });
                infoContents.forEach(content => content.classList.remove('active'));
                targetElement.forEach(element => element.classList.add('active'));
            }
        }
    });
});

document.querySelectorAll('.popup-buttons-container button').forEach(button => {
    button.addEventListener('click', () => {
        tabSection.scrollIntoView({ behavior: 'smooth' });
        const tabData = button.getAttribute('data-tab');
        const targetElement = document.getElementById(tabData);
        const infoContents = document.querySelectorAll('.pdp-tabs-v3 .info-content');

        if (tabData && targetElement) {
            tabsList.forEach(item => item.classList.remove('active'));
            tabIcons.forEach(icon => (icon.textContent = '+'));
            tabsList.forEach(item => {
                if(item.dataset.tab === tabData) {
                    item.classList.add('active');
                }
            });
            tabIcons.forEach(icon => {
                if(icon.parentElement.dataset.tab === tabData) {    
                    icon.textContent = '-';
                }
            });
            targetElement.classList.add('active');
        }
    })
});

document.querySelectorAll('.popup-buttons-container a').forEach(a => {
    a.addEventListener('click', () => {
        tabSection.scrollIntoView({ behavior: 'smooth' });
        const tabData = a.getAttribute('data-tab');
        const targetElement = document.getElementById(tabData);
        const infoContents = document.querySelectorAll('.pdp-tabs-v3 .info-content');
        if (tabData && targetElement) {
            tabsList.forEach(item => item.classList.remove('active'));
            tabIcons.forEach(icon => (icon.textContent = '+'));
            tabsList.forEach(item => {
                if(item.dataset.tab === tabData) {
                    item.classList.add('active');
                }
            });
            tabIcons.forEach(icon => {
                if(icon.parentElement.dataset.tab === tabData) {    
                    icon.textContent = '-';
                }
            });
            infoContents.forEach(content => content.classList.remove('active'));
            infoContents.forEach(content => {
                if (content.dataset.tab === tabData) {
                    content.classList.add('active');
                }
            });
            targetElement.classList.add('active');
        }
    })
});

const faqQuestions = document.querySelectorAll('.faq-questions .question');
const faqAnswers = document.querySelectorAll('.faq-answers .answer');

faqQuestions.forEach(question => {
    question.addEventListener('click', () => {
        const handle = question.getAttribute('data-handle');

        faqQuestions.forEach(q => {
            q.classList.remove('active');
        });

        question.classList.add('active');

        faqAnswers.forEach(answer => {
            if (answer.getAttribute('data-handle') === handle) {
                answer.classList.add('active');
            } else {
                answer.classList.remove('active');
            }
        });
    });
});

readMoreBtns.forEach(btn => {
    btn.addEventListener('click', () => {
        const btnTabData = btn.dataset.tab;

        if (window.innerWidth > tabletBreakPoint) {
            var matchingTab = document.querySelector(`.tabs-wrapper.desktop .tab-item[data-tab="${btnTabData}"]`);
            var scrollToContainer = tabSection;
        } else {
            var matchingTab = document.querySelector(`.tabs-wrapper.mobile .tab-item[data-tab="${btnTabData}"]`);
            var scrollToContainer = matchingTab;
        }
        scrollToContainer.scrollIntoView({ behavior: 'smooth' });
        matchingTab.click();
    });
});

//Overlay Gallery
const galleryOverlayToggles = document.querySelectorAll('.gallery-toggle');
const galleryOverlay = document.querySelector('.gallery-overlay');
const mainImageList = document.querySelectorAll('.main-image li');
const thumbnailContainers = document.querySelectorAll('.thumbnail-images');
const thumbnailImageList = document.querySelectorAll('.thumbnail-images li');
const activeThumbnails = document.querySelector('.thumbnail-images li.active');
const thumbnailButtons = document.querySelectorAll('.thumbnail-nav');

function openGallery(imageId) {
    galleryOverlay.classList.toggle('active');
    document.body.classList.toggle('modal-open');

    if (imageId) {
        const activeImage = document.querySelectorAll(`li[data-full="${imageId}"]`);

        mainImageList.forEach(image => { image.classList.remove('active'); });
        thumbnailImageList.forEach(image => { image.classList.remove('active'); });

        activeImage.forEach(element => {
           element.classList.add('active');
        });
        ensureActiveOverlayThumbVisible();
    }
};

function updateAcvitveImage(imageId) {
    // All main images in both gallery + overlay
    const mainImageList = document.querySelectorAll('.main-image li');
    // All li’s that correspond to this imageId (main + thumbs)
    const targetLis = document.querySelectorAll(`li[data-full="${imageId}"]`);

    // Clear all actives
    mainImageList.forEach(li => li.classList.remove('active'));
    thumbnailImageList.forEach(li => li.classList.remove('active'));

    // Activate every li that matches this imageId
    targetLis.forEach(li => li.classList.add('active'));
}

// Helper to keep the active thumbnail in view
function ensureActiveOverlayThumbVisible() {

    if (!activeThumbnails.length || !thumbnailContainers.length) return;

    thumbnailContainers.forEach(container => {
        const active = container.querySelector('li.active');
        if (!active) return;

        const liLeft = active.offsetLeft;
        const liWidth = active.offsetWidth;
        const containerWidth = container.clientWidth;

        const targetScrollLeft = liLeft - (containerWidth - liWidth) / 2;

        container.scrollTo({
            left: targetScrollLeft,
            behavior: 'smooth'
        });
    });
}

// Gallery toggle
galleryOverlayToggles.forEach(toggler => {
    toggler.addEventListener('click', () => {
        openGallery(toggler.dataset.full);
    });
});

// Thumbnail click
thumbnailImageList.forEach(thumbnail => {
    thumbnail.addEventListener('click', () => {
        thumbnailImageList.forEach(thumbnail => {
            thumbnail.classList.remove('active');
        })
        updateAcvitveImage(thumbnail.dataset.full);
    });
});

// Overlay Buttons
thumbnailButtons.forEach(button => {
    button.addEventListener('click', () => {
        const activeThumbnails = document.querySelectorAll('.thumbnail-images li.active');
        const allThumbs = document.querySelectorAll('.thumbnail-images li');
        const direction = parseInt(button.value, 10);

        activeThumbnails.forEach(element => {
            element.classList.remove('active');

            let target;

            if (direction === -1) {
                target = element.nextElementSibling || allThumbs[0];
            } else if (direction === 1) {
                target = element.previousElementSibling || allThumbs[allThumbs.length - 1];
            }

            target.classList.add('active');
            updateAcvitveImage(target.dataset.full);
        });
    });
});